/* PARWIN: keep the price shown on the product-page Add to Cart button in sync with the selected variant */
(function () {
  function apply() {
    document.querySelectorAll('.pp-atc-price-map').forEach(function (mapEl) {
      var comp = mapEl.closest('add-to-cart-component'); if (!comp) return;
      var span = comp.querySelector('[data-pp-atc-price]'); if (!span) return;
      var form = comp.closest('form') || comp.closest('product-form-component') || document;
      var input = form.querySelector('[ref="variantId"]') || form.querySelector('input[name="id"]');
      var vid = input && input.value; if (!vid) return;
      var map; try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }
      var d = map[vid]; if (!d) return;
      span.innerHTML = '&middot;&nbsp;<span class="pp-atc-price__now">' + d.p + '</span>';
    });
  }
  if (document.readyState !== 'loading') apply(); else document.addEventListener('DOMContentLoaded', apply);
  document.addEventListener('variant:update', function () { setTimeout(apply, 30); });
})();
